<template>
  <v-card class="pa-6" rounded="lg">
    <v-row justify="center">
      <v-col cols="12" class="text-center pb-0">
        <v-icon color="primary" size="64">mdi-bank-transfer</v-icon>
      </v-col>
      
      <v-col cols="12" class="text-center pt-2">
        <h2 class="headline font-weight-bold primary--text">
          Instrucciones de Pago Peibo
        </h2>
      </v-col>

      <v-col cols="12" class="pt-6">
        <v-card outlined class="pa-4" color="grey lighten-4">
          <v-row>
            <v-col cols="12">
              <p class="subtitle-1 font-weight-bold mb-2">
                <v-icon small class="mr-2">mdi-numeric-1-circle</v-icon>
                CLABE para transferencia:
              </p>
              <v-card class="pa-3 text-center" color="white">
                <p class="headline font-weight-bold mb-0 monospace-text">
                  {{ clabe }}
                </p>
              </v-card>
              <div class="text-center mt-2">
                <v-btn
                  small
                  outlined
                  color="primary"
                  @click="copyCLABE"
                >
                  <v-icon small left>mdi-content-copy</v-icon>
                  Copiar CLABE
                </v-btn>
              </div>
            </v-col>

            <v-col cols="12" class="pt-6">
              <p class="subtitle-1 font-weight-bold mb-2">
                <v-icon small class="mr-2">mdi-numeric-2-circle</v-icon>
                Datos del beneficiario:
              </p>
              <v-list dense class="transparent">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Nombre:</v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ beneficiary }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Concepto de pago:</v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ paymentConcept }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Monto a pagar:</v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium text-h6 primary--text">
                      {{ amount }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>

            <v-col cols="12" class="pt-4">
              <p class="subtitle-1 font-weight-bold mb-2">
                <v-icon small class="mr-2">mdi-numeric-3-circle</v-icon>
                Pasos a seguir:
              </p>
              <ol class="body-1 pl-4">
                <li class="mb-2">Ingresa a tu aplicación bancaria</li>
                <li class="mb-2">Selecciona la opción de "Transferencia SPEI"</li>
                <li class="mb-2">Ingresa la CLABE proporcionada arriba</li>
                <li class="mb-2">Verifica el nombre del beneficiario</li>
                <li class="mb-2">Ingresa el monto exacto a pagar</li>
                <li class="mb-2">Añade el concepto de pago (tu ID de orden)</li>
                <li class="mb-2">Confirma y autoriza la transferencia</li>
                <li class="mb-2">Guarda tu comprobante de pago</li>
              </ol>
            </v-col>

            <v-col cols="12">
              <v-alert
                dense
                outlined
                type="error"
                class="mb-0"
              >
                <div class="body-2">
                  <v-icon small class="mr-1">mdi-clock-outline</v-icon>
                  <strong>Importante:</strong> Tu pago será procesado en un máximo de 24 horas hábiles.
                  Recibirás un correo de confirmación una vez que se haya verificado tu transferencia.
                </div>
              </v-alert>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="12" class="text-center pt-4">
        <p class="caption grey--text">
          Por favor, conserva tu comprobante de pago hasta que recibas la confirmación por correo electrónico.
        </p>
      </v-col>
    </v-row>

    <v-snackbar
      v-model="snackbar"
      :timeout="2000"
      color="success"
      top
    >
      <v-icon color="white" class="mr-2">mdi-check-circle</v-icon>
      CLABE copiada al portapapeles
    </v-snackbar>
  </v-card>
</template>

<script>
export default {
  name: "PeiboInstructions",
  props: {
    clabe: {
      type: String,
      default: "646180115400000001",
    },
    beneficiary: {
      type: String,
      default: "WeChamber S.A. de C.V.",
    },
    paymentConcept: {
      type: String,
      required: true,
    },
    amount: {
      type: String,
      required: true,
    },
    expirationDate: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      snackbar: false,
    };
  },
  methods: {
    copyCLABE() {
      navigator.clipboard.writeText(this.clabe).then(() => {
        this.snackbar = true;
      }).catch(err => {
        console.error('Error al copiar CLABE:', err);
      });
    },
  },
};
</script>

<style scoped>
.monospace-text {
  font-family: 'Courier New', monospace;
  letter-spacing: 2px;
}

ol li {
  line-height: 1.8;
}
</style>
